<template>
  <div>
    <!-- Edit -->
    <a-modal v-model="visible" title="Edit student exam remark" onOk="handleOk" :destroyOnClose="true">
      <template slot="footer">
          <a-button key="back" @click="handleCancel">Cancel</a-button>
          <a-button key="submit" type="primary" :loading="loading" @click="handleEdit">Update Remark</a-button>
      </template>
      <a-spin :spinning="spinning">
          <a-form class="mb-4" :form="form" @submit="handleEdit">
            <a-form-item label="Remark">
              <a-input
                placeholder="Remark"
                v-decorator="['exam_remark', {rules: [{ required: true, message: 'Please input a remark!' }]}]"
              />
            </a-form-item>
          </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { feeTypes } from '@/services/globaldata'

export default {
  name: 'EditExamRemark',
  props: ['enrollmentId', 'classSectionExamId'],
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      remarkId: null,
      feeTypes,
    }
  },
  mounted: function () {
    this.$eventBus.$on('openExamRemarkEditModal', this.showModal)
  },
  computed: mapState(['user']),
  methods: {
    showModal: function(remarkId) {
      this.visible = true
      this.loading = true
      this.spinning = true
      this.remarkId = remarkId
      this.$http.get(`/api/studentexamremark/${remarkId}`)
        .then(({ data }) => {
          const fieldsData = {
            exam_remark: data.data.exam_remark,
          }
          this.form.setFieldsValue(fieldsData)
          this.spinning = false
          this.loading = false
        })
    },
    handleEdit: function (e) {
      e.preventDefault()
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to update the remark!`,
            onOk: () => {
              this.$http
                .patch(`/api/studentexamremark/${this.remarkId}`, {
                  enrollment_id: this.enrollmentId,
                  class_section_exam_id: this.classSectionExamId,
                  exam_remark: values.exam_remark,
                  exam_remark_by: this.user.user.first_name + ' ' + this.user.user.last_name,
                  exam_remark_type: 'normal',
                })
                .then(({ data }) => {
                  this.$emit('edited')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Successfully updated!',
                    description: `Remark has been updated successfully!`,
                  })
                  this.form.resetFields()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }
      })
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
  },
}
</script>
